module.exports = __webpack_public_path__ + "img/rules-splash.169b3d31.svg";